import React, { useState, useEffect } from 'react';
import { formatDate } from 'react-day-picker/moment';
import { DateTime } from 'luxon';
import { useGlobalState } from 'state-pool';

import Label from '../../../components/label';
import TextNumber from '../../../components/text-number';
import ReportButton from '../../../components/report-button';
import DayPicker from '../../../components/day-picker';
import Select from '../../../components/select';
import { getData, getFile } from '../../../helper/request-response';
import { downloadFile } from '../../../helper/util';
import constant from '../../../config/constant';
import purchaseSalesPath from './config';
import LoaderType from '../../../components/loader-type';

const List = () => {

    const [isLoad, setIsLoad] = useState(true);

    const [materialBuId, ,] = useGlobalState('materialBuId');

    const [startDate, setStartDate] = useState(DateTime.local());

    const [endDate, setEndDate] = useState(DateTime.local());

    const [reset, setReset] = useState();

    const [selectedGns, setSelectedGns] = useState(constant.DEFAULT_SELECTED);

    const [gnsId, setGnsId] = useState();

    const [purchaseSales, setPurchaseSales] = useState([]);

    const onEndDateChange = day => setEndDate(formatDate(day, constant.DEFAULT_DATE));

    const onStartDateChange = day => {

        setStartDate(formatDate(day, constant.DEFAULT_DATE));

        setEndDate(formatDate(day, constant.DEFAULT_DATE));
    
    };

    const getPurchaseSales = () => {

        const params = getParams();

        setIsLoad(true);

        getData(purchaseSalesPath.base, params).then(result => {
            
            setPurchaseSales(result[0]);

            setIsLoad(false);
        
        });
    }

    const getParams = () => {

        const params = {
            params: { 
                'start-date': DateTime.fromISO(startDate).toFormat(constant.PARAM_DATE_FORMAT),
                'end-date': DateTime.fromISO(endDate).toFormat(constant.PARAM_DATE_FORMAT),
                'gns-id': gnsId,
                'bu-id': materialBuId
            }
        };

        return params;
    }

    const onNameChange = opt => {

        if (opt.id) {
            
            setSelectedGns(name => ({
                ...name,
                value: opt.id,
                label: opt.label
            }));

            setGnsId(opt.id);

        }

    }
    
    const onExport = e => {

        e.preventDefault();

        const params = getParams();

        getFile(purchaseSalesPath.purchaseSalesExcel, params).then(response => downloadFile(response));

    }

    const onSubmit = e => {

        e.preventDefault();

        getPurchaseSales();

    }

    const onReset = e => {

        e.preventDefault();

        setIsLoad(true);

        setStartDate(DateTime.local());

        setEndDate(DateTime.local());

        setSelectedGns(constant.DEFAULT_SELECTED);

        setGnsId();

        setReset('reset');
    }

    useEffect(getPurchaseSales, [reset]);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{ purchaseSalesPath.title }</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) }>
                            
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <Label htmlFor="start-date" text="Tanggal Dari" />
                                    <DayPicker id="start-date" name="start-date" onDayChange={ onStartDateChange } valueDate={ startDate } />
                                </div>
                                <div className="col-md-6">
                                    <Label htmlFor="end-date" text="Tanggal Ke" />
                                    <DayPicker id="end-date" name="end-date" onDayChange={ onEndDateChange } valueDate={ endDate } />
                                </div>
                            </div>

                            <div className="form-group row">
                                
                                <div className="col-md-12">
                                    <Label htmlFor="gns-name" text="Nama Barang" />
                                    <Select
                                        id="gns-name"
                                        api={ purchaseSalesPath.purchaseSalesFind }
                                        entityId={materialBuId}
                                        onChange={ onNameChange }
                                        value={ selectedGns }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <ReportButton isSubmit={ true } onClick={ onReset } onExport={ onExport }/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {
                    isLoad &&
                    <LoaderType />
                }
                
                {
                    !isLoad && purchaseSales.length > 0 &&
                    <>
                        <br />
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover card-text">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Kode Barang</th>
                                                <th>Nama Barang</th>
                                                <th>Kode Satuan</th>
                                                <th>Satuan</th>
                                                <th>Jumlah Pembelian</th>
                                                <th>Harga Pembelian (Rp)</th>
                                                <th>Jumlah Penjualan</th>
                                                <th>Harga Penjualan (Rp)</th>
                                                <th>Laba Rugi (Rp)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                purchaseSales.map((ps, index) => {
                                                    return(
                                                        <tr key={ index }>
                                                            <td>{ index + 1 }</td>
                                                            <td>{ ps.gnsCode }</td>
                                                            <td>{ ps.gnsName }</td>
                                                            <td>{ ps.unitCode }</td>
                                                            <td>{ ps.unit }</td>
                                                            <td><TextNumber value={ ps.purchaseQty } /></td>
                                                            <td><TextNumber value={ ps.purchasePrice } /></td>
                                                            <td><TextNumber value={ ps.salesQty } /></td>
                                                            <td><TextNumber value={ ps.salesPrice } /></td>
                                                            <td><TextNumber value={ ps.profit } /></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
};

export default List;
